const LOGIN_RATE_LIMIT_MESSAGES: Record<string, string> = {
  en: 'You have tried to log in more than 5 times in a few minutes. For safety reasons the account is not accessible for 15 minutes. Please contact us on support@farmersplan.com if you need assistance',
  se: 'Du har försökt logga in mer än 5 gånger på några minuter. Av säkerhetsskäl är kontot inte tillgängligt i 15 minuter. Kontakta oss på support@farmersplan.com om du behöver hjälp',
};

export const getLoginRateLimitMessage = (language: string): string =>
  LOGIN_RATE_LIMIT_MESSAGES[language] || LOGIN_RATE_LIMIT_MESSAGES.se;
